import { render, staticRenderFns } from "./campaignInfo.vue?vue&type=template&id=3d808d60"
import script from "./campaignInfo.vue?vue&type=script&lang=js"
export * from "./campaignInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports